var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"})
}
var staticRenderFns = []

export { render, staticRenderFns }